module.exports = __webpack_public_path__ + "img/p3.fcd8da74.png";